import React from 'react';

import { Container, TextWrapper, Text, HighlightText } from './styles';
import Timeline from '../Timeline';
import ResponsiveTimeline from '../ResponsiveTimeline';

import { timeline } from '../../../static/data/timeline.json';

function TimelineSection() {
  return (
    <Container>
      <TextWrapper>
        <Text>
        Após tornar-se parceiro da Precatórios Brasil, você tem acesso à nossa plataforma exclusiva para gestão de Precatórios. Trata-se de uma excelente ferramenta para acompanhar os processos de seus clientes de
          maneira prática e transparente.
        </Text>
        <HighlightText>
          Conheça as etapas necessárias para conclusão do processo, desde a
          consulta do Precatório até o seu recebimento:
        </HighlightText>
      </TextWrapper>
      <ResponsiveTimeline timeline={timeline} />
      <Timeline timeline={timeline} />
    </Container>
  );
}

export default TimelineSection;
